import React, { forwardRef } from 'react'
import cx from 'classnames'

const PageSubtitle = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-page-subtitle')

  return (
    <h2
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

export default PageSubtitle
